import { controls,grouped } from "../controls";
const account_joint = {
label: "Account Joints",
pageLabel: "Account Joints",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Account",star:false}),
...controls.oc({ tab: "general", c: "Account", placeHolder: "Account Code", name: "account_code", isRequired:false,fastpath:"accounts"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "account_display"}),
...controls.displayText({ tab: "general", label: "Customer",star:false}),
...controls.oc({ tab: "general", c: "Customer", placeHolder: "Customer Code", name: "customer_code", isRequired:false,fastpath:"customers"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "customer_display"}),
...controls.magicDateLabel({ tab: "general", label: "Given Date",target: "given_date",star:false}),
...controls.magicDate({ tab: "general", name: "given_date", dateType: "ontype",isRequired:false }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.magicDateLabel({ tab: "general", label: "Upto Date",target: "upto_date",star:false}),
...controls.magicDate({ tab: "general", name: "upto_date", dateType: "ontype",isRequired:false }),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "Sign Reqd",default:false, name: "sign_reqd" }),
...controls.displayText({ tab: "general", label: "Joint Type",star:false}),
...controls.oc({ tab: "general", c: "JointType", placeHolder: "Joint Type Code", name: "joint_type_code", isRequired:false,fastpath:"joint_types",autoopen:true}),
...controls.showData({ tab: "general", displaytype: "capital", data: "joint_type_display"}),
]
,history:{
perPage: 10,
reportHeader: "Account Joints",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
]}};
export default account_joint;